import { Link, useLocation } from "react-router-dom";
import ThemeMaker from "../../components/thememaker";
import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../utils/config";
import { toast } from "react-toastify";
import { Tag } from 'antd';

const VariantsList = () => {
    const { apiEndpoint, awsKeyId, awsSecretKey, awsRegion, awsBucket, baseNodeapiUrl } = config;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const productId = queryParams.get("variation_id")
    const product_type_id = queryParams.get("product_type_id")
    const category_id = queryParams.get("category_id")
    const [variants, setVariants] = useState([]);
    console.log("variants578678", variants)

    const fetchVariants = async () => {
        try {
            const response = await axios({
                url: `${apiEndpoint}/snp/products/get-variation/${productId}`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
            })
            setVariants(response?.data?.variants || []);   // ✅ flat array, direct set
            console.log("response variants ---------->", response?.data);
        } catch (error) {
            console.error("Error fetching variants:", error);
        }
    }

    useEffect(() => {
        if (productId) {
            fetchVariants();
        } else {
            toast.error("Product ID is missing in the URL");
        }
    }, [])

    return (
        <ThemeMaker>
            <div className=" mx-auto p-3">
                <div className="d-flex justify-content-end">
                    <Link to={`/addvariants?productId=${productId}&product_type_id=${product_type_id}&category_id=${category_id} `}>
                        <Tag color='orange' className="py-1">Add Variants</Tag>
                    </Link>
                </div>
                <div
                    className="align-items-start mt-3"
                    style={{
                        height: "72vh", overflow: "scroll",
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "12px"
                    }}
                >
                    {variants?.map((item, index) => {   // ✅ direct map, no nested .variants
                        const attributes = item.attributes || [];
                        return (
                            <Link
                                key={item?.id || index}
                                className="text-dark"
                                style={{ textDecoration: "none" }}
                                to={`/addvariants?variantId=${item?.id}&product_type_id=${product_type_id}&category_id=${category_id}`}
                            >
                                <div className="border d-flex align-items-center bg-white rounded rounded-4 p-2 h-100" style={{ gap: "10px" }}>
                                    <div className="text-center">
                                        <img
                                            src={item.image}
                                            alt="variant"
                                            style={{
                                                width: "100%",
                                                height: "120px",
                                                objectFit: "contain"
                                            }}
                                        />
                                    </div>

                                    <div className="m-0 productItem">
                                        <h6 className="mb-0">
                                            <strong>SKU : </strong> {item?.sku}
                                        </h6>

                                        <p className="mb-0">
                                            <strong>GTIN : </strong>
                                            <span>{item.gtin}</span>
                                        </p>

                                        <p className="mb-0">
                                            <strong>MRP : </strong>
                                            <span>₹{item?.price?.mrp}</span>
                                        </p>

                                        <p className="mb-0">
                                            <strong>Selling Price : </strong>
                                            <span>₹{item?.price?.selling_price}</span>
                                        </p>

                                        <p className="mb-0">
                                            <strong>Qty : </strong>
                                            <span>
                                                {item?.available_qty !== undefined && item?.available_qty !== null && item?.available_qty !== ""
                                                    ? Number(item.available_qty)
                                                    : (Array.isArray(item?.inventories) && item.inventories.length > 0
                                                        ? item.inventories.reduce((sum, inv) => sum + (Number(inv.available_qty ?? inv.quantity ?? 0)), 0)
                                                        : (item?.quantity ?? 0))}
                                            </span>
                                        </p>

                                        {attributes.length > 0 && attributes.map((attr, i) => (
                                            <p className="mb-0" key={i}>
                                                <strong>{attr.attribute_name} : </strong>
                                                <span> {attr.attribute_value}</span>
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </ThemeMaker>
    );
};

export default VariantsList;